"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7938],{

/***/ 87938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ JobPostPreview; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/formatters/timeSinceFormatter.ts
var timeSinceFormatter = __webpack_require__(65997);
// EXTERNAL MODULE: ./node_modules/@prisma/client/index-browser.js
var index_browser = __webpack_require__(70385);
// EXTERNAL MODULE: ./utils/classNames.ts
var classNames = __webpack_require__(43153);
// EXTERNAL MODULE: ./node_modules/remove-accents/index.js
var remove_accents = __webpack_require__(76826);
var remove_accents_default = /*#__PURE__*/__webpack_require__.n(remove_accents);
;// CONCATENATED MODULE: ./utils/getNormalisedUrlSlug.ts

const getNormalisedUrlSlug = (slug)=>{
    var ref, ref1, ref2, ref3;
    return slug && ((ref3 = (ref2 = (ref1 = (ref = remove_accents_default()(slug)) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.replace(/[^a-z0-9]/g, "-")) === null || ref2 === void 0 ? void 0 : ref2.replace(/-+/g, "-")) === null || ref3 === void 0 ? void 0 : ref3.replace(/^-|-$/g, ""));
};

;// CONCATENATED MODULE: ./utils/db/JobPost/getSlug.ts

const getSlug = (param)=>{
    let { shortId , title , organisationName  } = param;
    return getNormalisedUrlSlug("".concat(title, "-at-").concat(organisationName ? organisationName : "", "-").concat(shortId));
};

// EXTERNAL MODULE: ./utils/enumToLabel/organisationSizeToLabel.ts
var organisationSizeToLabel = __webpack_require__(54840);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/BanknotesIcon.js
var BanknotesIcon = __webpack_require__(12435);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/MapPinIcon.js
var MapPinIcon = __webpack_require__(76850);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/GlobeAltIcon.js
var GlobeAltIcon = __webpack_require__(47950);
// EXTERNAL MODULE: ./components/JobPost/blocks/OnsiteLocationsBlock.tsx
var OnsiteLocationsBlock = __webpack_require__(85563);
// EXTERNAL MODULE: ./components/JobPost/blocks/RemoteLocationsBlock.tsx + 4 modules
var RemoteLocationsBlock = __webpack_require__(11296);
// EXTERNAL MODULE: ./utils/db/Compensation/getCompensationAsString.ts + 1 modules
var getCompensationAsString = __webpack_require__(32246);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/querystring-es3/index.js
var querystring_es3 = __webpack_require__(97334);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/WorkOutline.js
var WorkOutline = __webpack_require__(91447);
;// CONCATENATED MODULE: ./components/JobPost/JobPostPreview.tsx















const JobPostPreview = (param)=>{
    let { jobPost , hasSize =false , hasOrganisationAbout =false , cN =""  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    const router = (0,next_router.useRouter)();
    const urlSearchParams = Object.values(router.query).length > 0 ? "?".concat(new URLSearchParams((0,querystring_es3.stringify)(router.query))) : "";
    // Tags.
    const tags = jobPost.userAssignedTags;
    const isFullTime = tags.map((t)=>t.id).includes("full-time");
    const isPartTime = tags.map((t)=>t.id).includes("part-time");
    const isContract = tags.map((t)=>t.id).includes("contract");
    const isInternship = tags.map((t)=>t.id).includes("internship");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,classNames/* classNames */.A)("flex justify-between", cN),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/company/".concat((ref = jobPost.hiringOrganisation) === null || ref === void 0 ? void 0 : ref.slug).concat(urlSearchParams),
                    className: "shrink-0 w-11 sm:w-16",
                    children: ((ref1 = jobPost.hiringOrganisation) === null || ref1 === void 0 ? void 0 : ref1.favicon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "rounded w-9 sm:w-12",
                        width: 48,
                        height: 48,
                        src: "".concat("https://xxshqbqasrbviwgjwzwp.supabase.co", "/storage/v1/object/public/public").concat(jobPost === null || jobPost === void 0 ? void 0 : (ref2 = jobPost.hiringOrganisation) === null || ref2 === void 0 ? void 0 : ref2.favicon),
                        alt: "".concat((jobPost === null || jobPost === void 0 ? void 0 : (ref3 = jobPost.hiringOrganisation) === null || ref3 === void 0 ? void 0 : ref3.name) || "", " logo")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center w-10 h-10 rounded bg-gray-100 ",
                        children: (ref4 = jobPost.hiringOrganisation) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.name) === null || ref5 === void 0 ? void 0 : ref5[0]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/company/".concat((ref6 = jobPost.hiringOrganisation) === null || ref6 === void 0 ? void 0 : ref6.slug).concat(urlSearchParams),
                                                    className: "inline font-black hover:underline",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "inline",
                                                        children: ((ref7 = jobPost.hiringOrganisation) === null || ref7 === void 0 ? void 0 : ref7.name) ? (ref8 = jobPost.hiringOrganisation) === null || ref8 === void 0 ? void 0 : ref8.name : (ref9 = jobPost.hiringOrganisation) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.webUrl) === null || ref10 === void 0 ? void 0 : ref10.replace("https://", "")
                                                    })
                                                }),
                                                hasSize && ((ref11 = jobPost.hiringOrganisation) === null || ref11 === void 0 ? void 0 : ref11.size) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-2 px-1 py-0.5 text-gray-600 bg-gray-100 rounded-sm text-xxs font-medium",
                                                    children: organisationSizeToLabel/* organisationSizeToLabel */.P[(ref12 = jobPost.hiringOrganisation) === null || ref12 === void 0 ? void 0 : ref12.size]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pl-1 text-xxs text-gray-300",
                                            children: jobPost.isSticky ? "featured" : (0,timeSinceFormatter/* minimalTimeSinceFormatter */.n)(new Date(jobPost.createdAt))
                                        })
                                    ]
                                }),
                                hasOrganisationAbout && ((ref13 = jobPost.hiringOrganisation) === null || ref13 === void 0 ? void 0 : ref13.about) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-0.5",
                                    children: (ref14 = jobPost.hiringOrganisation) === null || ref14 === void 0 ? void 0 : ref14.about
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/job/".concat(getSlug({
                                shortId: jobPost.shortId,
                                title: jobPost.title,
                                organisationName: (ref15 = jobPost.hiringOrganisation) === null || ref15 === void 0 ? void 0 : ref15.name
                            })).concat(urlSearchParams),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "mt-3 mb-2 text-base font-bold leading-tight text-blue-600 hover:underline",
                                children: jobPost.title
                            })
                        }),
                        (isFullTime || isPartTime || isContract || isInternship) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "my-1 text-xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkOutline/* default */.Z, {
                                    classes: {
                                        fontSizeInherit: "text-base"
                                    },
                                    fontSize: "inherit",
                                    className: "inline w-4 h-4 mr-1"
                                }),
                                isFullTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/search?tags=full-time",
                                    className: "hover:underline",
                                    rel: "nofollow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pr-2",
                                        children: "Full-time"
                                    })
                                }),
                                isPartTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/search?tags=part-time",
                                    className: "hover:underline",
                                    rel: "nofollow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pr-2",
                                        children: "Part-time"
                                    })
                                }),
                                isContract && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/search?tags=contract",
                                    className: "hover:underline",
                                    rel: "nofollow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pr-2",
                                        children: "Contract"
                                    })
                                }),
                                isInternship && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/search?tags=internship",
                                    className: "hover:underline",
                                    rel: "nofollow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pr-2",
                                        children: "Internship"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "items-center my-1 font-bold text-smX",
                            children: jobPost.compensation.min || jobPost.compensation.max ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BanknotesIcon/* default */.Z, {
                                        className: "inline w-4 h-4 mr-1"
                                    }),
                                    (0,getCompensationAsString/* getCompensationAsString */.D)(jobPost.compensation)
                                ]
                            }) : null
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-black",
                            children: [
                                ((ref16 = jobPost.locations) === null || ref16 === void 0 ? void 0 : ref16.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                            className: "inline mr-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MapPinIcon/* default */.Z, {
                                                    className: "inline w-4 h-4"
                                                }),
                                                " Onsite locations:"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OnsiteLocationsBlock/* OnsiteLocationsBlock */.$, {
                                            locations: jobPost.locations
                                        })
                                    ]
                                }),
                                (((ref17 = jobPost.remote) === null || ref17 === void 0 ? void 0 : ref17.type) === index_browser.JobPostRemoteType.WORLDWIDE || ((ref18 = jobPost.remote) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.regions) === null || ref19 === void 0 ? void 0 : ref19.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                            className: "inline mr-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobeAltIcon/* default */.Z, {
                                                    className: "inline w-4 h-4"
                                                }),
                                                " Hires remotely in:"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteLocationsBlock/* RemoteLocationsBlock */.D, {
                                            remote: jobPost.remote
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 85563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ OnsiteLocationsBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43153);



const OnsiteLocationsBlock = (param)=>{
    let { locations  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "inline",
        children: locations.map((loc, i, arr)=>{
            const address = loc.formattedAddress || loc.address;
            return address ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .A)("inline", i < arr.length - 1 && "after:content-['•'] after:px-1.5"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "/search?location=".concat(address.replace(",", " ")),
                    className: "hover:underline",
                    rel: "nofollow",
                    children: address
                })
            }, i) : null;
        })
    });
};


/***/ }),

/***/ 11296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ RemoteLocationsBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@prisma/client/index-browser.js
var index_browser = __webpack_require__(70385);
;// CONCATENATED MODULE: ./utils/valueToUrlString.ts
const valueToUrlString = (value)=>{
    return value.toLowerCase().replace(/\s/g, "-").replace(/[^a-z0-9-]/g, "");
};

;// CONCATENATED MODULE: ./data/countries.ts
const countries = {
    AD: "Andorra",
    AE: "United Arab Emirates",
    AF: "Afghanistan",
    AG: "Antigua and Barbuda",
    AI: "Anguilla",
    AL: "Albania",
    AM: "Armenia",
    AO: "Angola",
    AQ: "Antarctica",
    AR: "Argentina",
    AS: "American Samoa",
    AT: "Austria",
    AU: "Australia",
    AW: "Aruba",
    AX: "\xc5land Islands",
    AZ: "Azerbaijan",
    BA: "Bosnia and Herzegovina",
    BB: "Barbados",
    BD: "Bangladesh",
    BE: "Belgium",
    BF: "Burkina Faso",
    BG: "Bulgaria",
    BH: "Bahrain",
    BI: "Burundi",
    BJ: "Benin",
    BL: "Saint Barth\xe9lemy",
    BM: "Bermuda",
    BN: "Brunei",
    BO: "Bolivia",
    BQ: "Caribbean Netherlands",
    BR: "Brazil",
    BS: "Bahamas",
    BT: "Bhutan",
    BV: "Bouvet Island",
    BW: "Botswana",
    BY: "Belarus",
    BZ: "Belize",
    CA: "Canada",
    CC: "Cocos Islands",
    CD: "Democratic Republic of the Congo",
    CF: "Central African Republic",
    CG: "Republic of the Congo",
    CH: "Switzerland",
    CI: "Ivory Coast",
    CK: "Cook Islands",
    CL: "Chile",
    CM: "Cameroon",
    CN: "China",
    CO: "Colombia",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Cabo Verde",
    CW: "Cura\xe7ao",
    CX: "Christmas Island",
    CY: "Cyprus",
    CZ: "Czechia",
    DE: "Germany",
    DJ: "Djibouti",
    DK: "Denmark",
    DM: "Dominica",
    DO: "Dominican Republic",
    DZ: "Algeria",
    EC: "Ecuador",
    EE: "Estonia",
    EG: "Egypt",
    EH: "Western Sahara",
    ER: "Eritrea",
    ES: "Spain",
    ET: "Ethiopia",
    FI: "Finland",
    FJ: "Fiji",
    FK: "Falkland Islands",
    FM: "Micronesia",
    FO: "Faroe Islands",
    FR: "France",
    GA: "Gabon",
    GB: "United Kingdom",
    GD: "Grenada",
    GE: "Georgia",
    GF: "French Guiana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Greenland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Guadeloupe",
    GQ: "Equatorial Guinea",
    GR: "Greece",
    GS: "South Georgia and the South Sandwich Islands",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HK: "Hong Kong",
    HM: "Heard Island and McDonald Islands",
    HN: "Honduras",
    HR: "Croatia",
    HT: "Haiti",
    HU: "Hungary",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IM: "Isle of Man",
    IN: "India",
    IO: "British Indian Ocean Territory",
    IQ: "Iraq",
    IR: "Iran",
    IS: "Iceland",
    IT: "Italy",
    JE: "Jersey",
    JM: "Jamaica",
    JO: "Jordan",
    JP: "Japan",
    KE: "Kenya",
    KG: "Kyrgyzstan",
    KH: "Cambodia",
    KI: "Kiribati",
    KM: "Comoros",
    KN: "Saint Kitts and Nevis",
    KP: "North Korea",
    KR: "South Korea",
    KW: "Kuwait",
    KY: "Cayman Islands",
    KZ: "Kazakhstan",
    LA: "Laos",
    LB: "Lebanon",
    LC: "Saint Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Lithuania",
    LU: "Luxembourg",
    LV: "Latvia",
    LY: "Libya",
    MA: "Morocco",
    MC: "Monaco",
    MD: "Moldova",
    ME: "Montenegro",
    MF: "Saint Martin",
    MG: "Madagascar",
    MH: "Marshall Islands",
    MK: "North Macedonia",
    ML: "Mali",
    MM: "Myanmar",
    MN: "Mongolia",
    MO: "Macao",
    MP: "Northern Mariana Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Maldives",
    MW: "Malawi",
    MX: "Mexico",
    MY: "Malaysia",
    MZ: "Mozambique",
    NA: "Namibia",
    NC: "New Caledonia",
    NE: "Niger",
    NF: "Norfolk Island",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Netherlands",
    NO: "Norway",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "New Zealand",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "French Polynesia",
    PG: "Papua New Guinea",
    PH: "Philippines",
    PK: "Pakistan",
    PL: "Poland",
    PM: "Saint Pierre and Miquelon",
    PN: "Pitcairn",
    PR: "Puerto Rico",
    PS: "Palestine",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Qatar",
    RE: "R\xe9union",
    RO: "Romania",
    RS: "Serbia",
    RU: "Russia",
    RW: "Rwanda",
    SA: "Saudi Arabia",
    SB: "Solomon Islands",
    SC: "Seychelles",
    SD: "Sudan",
    SE: "Sweden",
    SG: "Singapore",
    SH: "Saint Helena",
    SI: "Slovenia",
    SJ: "Svalbard and Jan Mayen",
    SK: "Slovakia",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    SS: "South Sudan",
    ST: "Sao Tome and Principe",
    SV: "El Salvador",
    SX: "Sint Maarten",
    SY: "Syria",
    SZ: "Eswatini",
    TC: "Turks and Caicos Islands",
    TD: "Chad",
    TF: "French Southern Territories",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tajikistan",
    TK: "Tokelau",
    TL: "Timor-Leste",
    TM: "Turkmenistan",
    TN: "Tunisia",
    TO: "Tonga",
    TR: "Turkey",
    TT: "Trinidad and Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tanzania",
    UA: "Ukraine",
    UG: "Uganda",
    // UK: "United Kingdom", // duplicate of GB
    // UM: "United States Minor Outlying Islands",
    US: "United States",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VA: "Holy See",
    VC: "Saint Vincent and the Grenadines",
    VE: "Venezuela",
    VG: "Virgin Islands (UK)",
    VI: "Virgin Islands (US)",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis and Futuna",
    WS: "Samoa",
    YE: "Yemen",
    YT: "Mayotte",
    ZA: "South Africa",
    ZM: "Zambia",
    ZW: "Zimbabwe"
};

// EXTERNAL MODULE: ./data/regions.ts
var regions = __webpack_require__(3837);
;// CONCATENATED MODULE: ./data/remoteRegions/remoteRegions.ts



var RegionType;
(function(RegionType) {
    RegionType["COUNTRY"] = "COUNTRY";
    RegionType["REGION"] = "REGION";
    RegionType["TIMEZONE"] = "TIMEZONE";
})(RegionType || (RegionType = {}));
const remoteRegions = [
    ...Object.entries(countries).map((param)=>{
        let [key, value] = param;
        return {
            id: key.toLocaleLowerCase(),
            name: value,
            type: RegionType.COUNTRY
        };
    }),
    ...Object.entries(regions/* regions */.U).map((param)=>{
        let [key, value] = param;
        return {
            id: valueToUrlString(value.name),
            name: value.name,
            countries: value.countries.map((country)=>country.toLocaleLowerCase()),
            type: RegionType.REGION
        };
    }),
    ...Object.entries(regions/* timeZones */.W).map((param)=>{
        let [key, value] = param;
        return {
            id: valueToUrlString(key),
            name: key,
            countries: value.countries.map((country)=>country.toLocaleLowerCase()),
            type: RegionType.TIMEZONE
        };
    })
];

;// CONCATENATED MODULE: ./utils/regions/getRegionById.ts

const getRegionById = (regionId)=>remoteRegions.find((r)=>r.id === regionId);

// EXTERNAL MODULE: ./utils/classNames.ts
var classNames = __webpack_require__(43153);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/JobPost/blocks/RemoteLocationsBlock.tsx






const RemoteLocationsBlock = (param)=>{
    let { remote  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (remote === null || remote === void 0 ? void 0 : remote.type) === index_browser.JobPostRemoteType.WORLDWIDE ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/search",
            className: "hover:underline",
            children: "Worldwide"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "inline",
            children: remote === null || remote === void 0 ? void 0 : remote.regions.map((regionId, i, arr)=>{
                var ref;
                const regionName = (ref = getRegionById(regionId)) === null || ref === void 0 ? void 0 : ref.name;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (0,classNames/* classNames */.A)("inline", i < arr.length - 1 && "after:content-['•'] after:px-1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/search?location=".concat(regionName.replace(",", " ")),
                        className: "hover:underline",
                        rel: "nofollow",
                        children: regionName
                    })
                }, i);
            })
        })
    });
};


/***/ }),

/***/ 32246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ getCompensationAsString; }
});

// EXTERNAL MODULE: ./utils/enumToLabel/compensationUnitToLabel.ts
var compensationUnitToLabel = __webpack_require__(22536);
;// CONCATENATED MODULE: ./utils/formatters/kFormatter.ts
const kFormatter = (numStr)=>{
    const num = parseInt(numStr);
    if (typeof num !== "number") {
        return;
    }
    return Math.abs(num) > 9999 ? (Math.abs(num) / 1000).toFixed(0) + "k" : Math.abs(num) > 999 ? (Math.abs(num) / 1000).toFixed(1) + "k" : Math.abs(num) + "";
};

;// CONCATENATED MODULE: ./utils/db/Compensation/getCompensationAsString.ts


// Format as:
// - USD 110k-$193k/year
// - USD 110k/year
// - GBP 100k/year
const getCompensationAsString = (param)=>{
    let { min , max , currency , unit  } = param;
    var ref;
    // Return early if no compensation.
    if (!(max || min)) {
        return;
    }
    const compensationMaxFormatted = max ? kFormatter("".concat(max)) : "";
    const compensationMinFormatted = min ? kFormatter("".concat(min)) : "";
    const compensationUnit = (ref = compensationUnitToLabel/* compensationUnitToLabel */.W[unit]) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    return "".concat(currency, " ").concat(compensationMinFormatted && compensationMaxFormatted ? "".concat(compensationMinFormatted, "-").concat(compensationMaxFormatted) : compensationMinFormatted ? "from ".concat(compensationMinFormatted) : "up to ".concat(compensationMaxFormatted), "/").concat(compensationUnit);
};


/***/ }),

/***/ 22536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ compensationUnitToLabel; }
/* harmony export */ });
/* harmony import */ var _prisma_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70385);
/* harmony import */ var _prisma_client__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_prisma_client__WEBPACK_IMPORTED_MODULE_0__);

const compensationUnitToLabel = {
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.HOUR]: "Hour",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.DAY]: "Day",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.WEEK]: "Week",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.MONTH]: "Month",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.YEAR]: "Year"
};


/***/ }),

/***/ 54840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ organisationSizeToLabel; }
/* harmony export */ });
/* harmony import */ var _prisma_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70385);
/* harmony import */ var _prisma_client__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_prisma_client__WEBPACK_IMPORTED_MODULE_0__);

const organisationSizeToLabel = {
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.A]: "Self-employed",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.B]: "1-10 employees",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.C]: "11-50 employees",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.D]: "51-200 employees",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.E]: "201-500 employees",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.F]: "501-1000 employees",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.G]: "1001-5000 employees",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.H]: "5001-10,000 employees",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.OrganisationSize.I]: "10,001+ employees"
};


/***/ }),

/***/ 65997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ timeSinceFormatter; },
/* harmony export */   "n": function() { return /* binding */ minimalTimeSinceFormatter; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91713);

const timeSinceFormatter = (datetime, options)=>datetime ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(datetime, options) : "-";
const minimalTimeSinceFormatter = (datetime)=>datetime ? (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(datetime).replace(" days", "d").replace(" day", "d").replace(" hours", "h").replace(" hour", "h").replace(" minutes", "m").replace(" minute", "m").replace(" seconds", "s").replace(" second", "s") : "-";


/***/ })

}]);